import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { installFaviconSwitcher } from './router/favicon';
import './styles/base.css';

const app = createApp(App);

// keep the <body> data attribute in sync with route meta for theming
router.afterEach((to) => {
    const section = to.meta?.section || 'finance';
    document.body.setAttribute('data-section', section);
});

installFaviconSwitcher(router);

app.use(router).mount('#app');

// Tell the build-time prerenderer the page is done (routing + <head> settled).
router.isReady().then(() => {
    window.__PRERENDER_READY__ = true;
    document.dispatchEvent(new Event('x-app-rendered'));
});
